<template>
  <div class="center">
    <audio style="display: none" controls :src="url" @pause="handlePause" @canplay="getDuration" @timeupdate="updateTime" ref="audio"></audio>
    <div class="audio_box" :style="styles" @click.stop="handlePlay">
      <img src="../../assets/images/home/shengyin.png" alt="">
      <div>{{duration}}</div>
      <div class="abs">{{playTime}}</div>
    </div>
  </div>
</template>

<script>
  import {_changeTimeBySecond ,_addZero,_timeFormat} from '../../utils/index'
  export default {
    name: "Index",
    props:{
      styles: Object,
      url: {
        // 尺寸样式
        type: String,
        default: "mini"
      },
    },
    data(){
      return {
        flag:false,
        playTime:'',
        duration:null,
      }
    },
    methods:{
      getDuration(e){
        let duration  =_timeFormat(Math.round(e.target.duration ))
        this.duration = duration
        console.log(this.duration);
      },
      updateTime(e){
        let duration  =_timeFormat(Math.round(e.target.currentTime ))
        this.playTime = duration
        console.log(this.playTime);
      },
      handlePlay() {
        if(!this.flag){
          this.$refs.audio.play()
          this.flag = true
        }else{
          this.$refs.audio.pause()
          this.flag = false
        }
        return false
      },
      handlePause(){
        console.log(1);
      },
    },
  }
</script>
<style lang="stylus" scoped>
  div{
    box-sizing border-box
  }
  .center {
    .audio_box{
      border-radius: 150px;
      background-color: rgba(242, 242, 242, 1);
      display flex
      align-items center
      justify-content space-between
      padding 0 10px
      position relative
      >img{
        width: 16px
        height: 20px
        cursor: pointer
      }
      >div{
        font-size: 14px;
        color: #00A13A;
      }
      .abs{
        position absolute
        left:40px
        top:50%
        transform translateY(-50%)
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/audio/Index.vue